import {init as reinitCollapse} from './gsap-collapse.js';
import ResizeSensor from "resize-sensor";

window.ResizeSensor = ResizeSensor;

import 'sticky-sidebar/dist/jquery.sticky-sidebar.js';
// import RPC from './related-products-counter.js';

// const relatedProductsCounter = RPC();

function showLargeFilters(filtersGroup) {
  filtersGroup.each(function(){
      // Showing only first 10 elements
      var maxHeight = 0;
      var $facetsItems = $(this).find('.facets__list').find('.facets__item');
      var ul_padding = 20;

      if($facetsItems.length) {
          for (var i = 0; i < 5; ++i) {
            maxHeight = maxHeight + $($facetsItems[i]).outerHeight(true) - 1;
          }
      }

      $(this).find('.facets-list-container').css({'maxHeight': maxHeight + ul_padding});

      if($(this).find('.facets__list').height() > $(this).find('.facets-list-container').height()){
          $(this).find('.facets__list').addClass('bottom-shadow-effect');
          $(this).find('button.show-all-filters').show();
      } else {
        $(this).find('button.show-all-filters').hide();
        $(this).find('button.hide-filters').hide();
      }

      $(this).find('button.hide-filters').on('click', function(event){
          event.preventDefault();
          $(this).closest('.facets__display').find('.facets-list-container').css({'max-height': maxHeight + 'px'});
          $(this).hide();
          $(this).parent().find('button.show-all-filters').show();
      });

      $(this).find('button.show-all-filters').on('click', function(event){
          event.preventDefault();
          $(this).closest('.facets__display').find('.facets-list-container').css({'max-height': '100%'});
          $(this).hide();
          $(this).parent().find('button.hide-filters').show();
      });
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
   if (event.code.toUpperCase() !== 'ESCAPE') return;

   if($(window).width() < 768){
    const openDetailsElement = event.target.parents('.js-filter[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('.facets__summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
   }
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this?.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement?.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productList = document.getElementById('ProductGridContainer')?.querySelector('.products-list');
    if(productList) {
      productList.classList.add('loading');
    }
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {

      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductCount(html);
  }



  static renderProductGridContainer(html) {
    var $html = new DOMParser().parseFromString(html, 'text/html');
    var productGrid = $html.getElementById('ProductGridContainer').innerHTML;
    document.getElementById('ProductGridContainer').innerHTML = productGrid;
    reinitCollapse('.facet-filters.sorting');

    var anchorStart = window.location.href.indexOf('#');
    var itemID = anchorStart != -1 ? window.location.href.substr(anchorStart) : ''
    var preLoadingEnded = true; // Flag to check if were loading back pages
    var ajaxPageParamStart = window.location.href.indexOf('?i=');
    var ajaxPageParamEnd = anchorStart != -1 ? window.location.href.length - anchorStart : undefined;
    var ajaxPageNumber = ajaxPageParamStart != -1 ? parseInt(window.location.href.substr(ajaxPageParamStart, ajaxPageParamEnd).replace('?i=', '')) : false;

    if($html.querySelector('#ProductGridContainer .products-count')){
      const pagination = $html.querySelector('#ProductGridContainer .products-count');
      const pag_n = pagination.getAttribute('data-pagination');
      document.querySelector('#ProductGridContainer .products-count span').innerHTML= pag_n;
    }

    if(document.querySelector('#AjaxinatePagination .pagination a')){
      document.querySelector('#AjaxinatePagination .pagination a').addEventListener('click', function(event){
        event.target.classList.add('loading');
      });
    }

    showLargeFilters($('.facets__display'));
    FacetFiltersForm.sticky_sidebar.updateSticky();
    window.scrollTo({top: $('.collection-filters-wrapper').offset().top - 160});
    document.querySelector('#main-collection-filters .facets-container').style.position = 'relative';
    document.querySelector('#main-collection-filters .facets-container').style.transform = 'translate3d(0,0,0)';

    // Counting Tiles with related products (colors)
    // tilesWithRelatedProducts = document.querySelectorAll('[data-rel-products]');
    // relatedProductsCounter.run(tilesWithRelatedProducts);

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      method: 'scroll',
      callback: function(request, $html){
            // Re-initialize components after AJAX load
            if (window.lazySizes) {
                window.lazySizes.rv = [];
            }
            
            // Reinitialize image hover effect
            const $newTiles = $('#AjaxinateContainer').find('[data-img-change="true"]');
            $newTiles.each(function() {
                const $wrapper = $(this).find('.product--wrapper');
                if ($wrapper.length) {
                    $wrapper.off('mouseenter mouseleave');
                    $wrapper.on('mouseenter', function() {
                        $(this).find('.product-tile__image-wrapper--hover').fadeIn(200);
                    });
                    $wrapper.on('mouseleave', function() {
                        $(this).find('.product-tile__image-wrapper--hover').fadeOut(200);
                    });
                }
            });
            
            // Dispatch custom event for other components
            document.dispatchEvent(new CustomEvent("dagency:tiles-loaded"));

            var $proxyLinks = $('#AjaxinateContainer').find('[data-link-proxy]');
            if($proxyLinks.length) {
                $proxyLinks.off('click');

                $proxyLinks.ProxyLink({
                    excludes: ['.slick-dots', '.product-tile__variant', '.swym-add-to-wishlist-view-product' ],
                    onBeforeUnload: function($proxyLink) {
                        const itemID = $proxyLink.attr('id');
                        if(itemID) {
                            const requestedPageNum = window.location.href.substr(window.location.href.indexOf('?page=')).replace('?page=', '')
                            history.pushState({}, 'page ' + requestedPageNum, '?i='+requestedPageNum + '#' + itemID);
                        }
                    }
                });
            }

            // Init wishlist buttons
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

            // Scroll back to latest position
            if(request.indexOf('page=')) {
              var requestedPageNum = request.split('?')[1].split('&').filter(el => el.startsWith('page='))[0].split('=')[1];
            }
            var url_to_merge = request.split('?')[1].replace(`&page=${requestedPageNum}`, '').replace(`?page=${requestedPageNum}`, '');

            if (url_to_merge.includes('page=')) url_to_merge = '';

            if(preLoadingEnded) {
                window.endlessScroll.currentPage = requestedPageNum;
                history.pushState({}, 'page ' + requestedPageNum, '?i='+requestedPageNum + url_to_merge + itemID);
            }

            if(!window.endlessScroll.pagesToLoad) {
                const headersHeight = $('.site-header').outerHeight(true);

                if(itemID) {
                    var itemTop = $(itemID).offset().top - headersHeight;
                    window.scrollTo({left:0, top:itemTop, behavior: 'smooth'});
                    itemID = '';
                }
            }

            if(window.endlessScroll.pagesToLoad) {
                preLoadNextPage();
            }

            if($html.find('#ProductGridContainer .products-count').get(0)) {
              const pagination = $html.find('#ProductGridContainer .products-count').get(0);
              const pag_n = pagination.getAttribute('data-pagination');
              document.querySelector('#ProductGridContainer .products-count span').innerHTML= pag_n;
            }

            if(document.querySelector('#AjaxinatePagination .pagination a')){
              document.querySelector('#AjaxinatePagination .pagination a').classList.remove('loading');
              document.querySelector('#AjaxinatePagination .pagination a').addEventListener('click', function(event){
                event.target.classList.add('loading');
              });
            }

            // tilesWithRelatedProducts = document.querySelectorAll('[data-rel-products]');
            // relatedProductsCounter.run(tilesWithRelatedProducts);
        }
    });

    $('[data-link-proxy]').ProxyLink({
      excludes: ['.slick-dots', '.product-tile__variants', '.swym-add-to-wishlist-view-product']
    });

  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }

    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      // document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      var subElement = element.querySelector(`.js-filter[data-index="${element.dataset.index}"] ul`);
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"] ul`).innerHTML = subElement.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    showLargeFilters($('.facets__display'));

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement)
        return;
      activeFacetsElement.innerHTML.trim().length ? $('.active-facets__button-remove').show() : $('.active-facets__button-remove').hide();
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })



    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('ProductGridContainer').dataset.sectionId,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

if($('#main-collection-filters').length > 0) {
  FacetFiltersForm.sticky_sidebar = new StickySidebar(document.querySelector('#main-collection-filters'), {
    containerSelector: '.filters-drawer',
    innerWrapperSelector: '.facets-container',
    topSpacing: 150,
    bottomSpacing: 5,
    resizeSensor: true,
    stickyClass: 'is-affixed'
  });
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facets-remove', FacetRemove);


$(document).on('click', '.filter-wrapper .close-drawer', function() {
  $('#FacetsWrapperDesktop .filters-wrapper').attr('data-collapse-status', '');
  $('#FacetsWrapperDesktop .filter-wrapper').removeAttr('style');
  //$('.filter-container .js-filter').removeAttr('open');
});


$(document).on('click', '#FacetsWrapperDesktop .filters-wrapper .filters-wrapper, .filter-wrapper .close-drawer', function() {
  if($(window).width() < 768) {
    $('html').toggleClass('block-scroll');
  }
});


Shopify.queryParams = {};

if (location.search.length) {
  var params = location.search.substr(1).split('&');

  for (var i = 0; i < params.length; i++) {
    var keyValue = params[i].split('=');

    if (keyValue.length) {
      Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
    }
  }
}

$(document).on('change', '.facet-filters__select', function(e) {
  var value = e.target.value;
  Shopify.queryParams.sort_by = value;

  let params = JSON.stringify(Shopify.queryParams);
  params = params.replaceAll('"', '').replaceAll(':', '=').replaceAll(',', '&').replaceAll('{', '').replaceAll('}', '');
  params = encodeURIComponent(params);

  const searchParams = new URLSearchParams(`bin=${params}`);
  const query_search = searchParams.get('bin');
  location.search = query_search;
});

// let tilesWithRelatedProducts = document.querySelectorAll('[data-rel-products]');
// relatedProductsCounter.run(tilesWithRelatedProducts);

export {showLargeFilters};
